import React, { Component } from 'react'
import {RoomContext} from "../Context"
import Loading from "./loading";
import Room from "./Room"
import Title from "./Title"
export default class FeaturedRooms extends Component {
    static contextType = RoomContext;
    render() {
        let { loading,featuredRooms : rooms} = this.context;
        // console.log("context", this.context)
        rooms = rooms.map(room => {
            return <Room key={room.id} room={room}/>
        })
        // console.log('FEATURED',rooms)
        return (
            <section className="featured-rooms">
            <Title title="Featured Rooms"/>
            <div className="featured-rooms-center">
                {loading?<Loading/>:rooms}
            </div>

                
            </section >
        )
    }
}
